import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {
  applicationGetRecommendationsAPI,
  applicationSendRecommendationAPI,
} from "api/applications/applicationsApiHelper"
import Notify from "components/Common/notify"

const initialState = {
  applicationRecommendations: [],
  totalPages: 0,
  loading: false,
  error: null,
}

export const SendApplicationRecommendation = createAsyncThunk(
  "Applications/SendApplicationRecommendation",
  async data => {
    try {
      const response = await applicationSendRecommendationAPI(data)
      if (response?.status === 200) {
        let _response = {
          data: response?.data,
          status: response?.status,
          postData: data,
        }
        return _response
      } else {
        Notify("error", "Failed to send recomendation")
        throw Error("Failed to send recomendation")
      }
    } catch (error) {
      let errorMessage = error?.response?.data?.message || "Failed to send recomendation"
      console.log("Failed to send recomendation", error)
      if (
        error?.response?.data?.message ===
        "Assigned staff didn't recommend yet."
      ) {
        Notify(
          "error",
          "Assigned staff didn't recommend yet. You cannot send recommendation before assigned staff.",
        )
        throw Error(
          "Assigned staff didn't recommend yet. You cannot send recommendation before assigned staff.",
        )
      } else {
        Notify("error", errorMessage)
        throw Error("Failed to send recomendation")
      }
    }
  },
)

export const GetApplicationRecommendation = createAsyncThunk(
  "Applications/GetApplicationRecommendation",
  async staffId => {
    try {
      const response = await applicationGetRecommendationsAPI(staffId)
      if (response?.status === 200) {
        let _response = {
          data: response?.data,
          status: response?.status,
          // postData: data,
        }
        return _response
      } else {
        Notify("error", "Failed to fetch comment")
        throw Error("Failed to fetch comment")
      }
    } catch (error) {
      Notify("error", "Failed to fetch comment")
      throw Error("Failed to fetch comment")
    }
  },
)

export const applicationRecommendationSlice = createSlice({
  name: "applicationRecommendations",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(SendApplicationRecommendation.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(SendApplicationRecommendation.fulfilled, (state, action) => {
        state.loading = false
        console.log("Recommendation sent successfully", action.payload)
      })
      .addCase(SendApplicationRecommendation.rejected, (state, action) => {
        state.loading = false
        state.error = true
      })

    builder
      .addCase(GetApplicationRecommendation.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(GetApplicationRecommendation.fulfilled, (state, action) => {
        state.loading = false
        console.log(
          "Recommendation fetched successfully",
          action.payload?.data?.items?.recommendations,
        )
        state.applicationRecommendations =
          action.payload?.data?.items?.recommendations
      })
      .addCase(GetApplicationRecommendation.rejected, (state, action) => {
        state.loading = false
        state.error = true
      })
  },
})

export default applicationRecommendationSlice.reducer
export const allApplicationRecommendations = state =>
  state.allApplicationRecommendations
